import React from 'react'
import styles from './GridScreen.module.css';

function GridScreen() {
  return (
      <>
    <div className={styles.container}>


       <div className={styles.child}>
           oThere are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>

       <div className={styles.child}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>

       <div className={styles.child}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>
       <div className={styles.child}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>
       <div className={styles.child}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>
    </div>

<div className={styles.container2}>
    <div className={styles.child2}>Hello</div>
    

</div>

<div className={styles.container3}>
    
There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.

</div>

<div className={styles.container4}>
    <img src='https://images.squarespace-cdn.com/content/v1/53b839afe4b07ea978436183/0b8eb859-676e-4848-8fa3-f21df76b9e47/beautiful-villages-in-switzerland-grindelwald.jpg' alt/>
    <div className={styles.child4}>
        <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    </div>
</div>


<div className={styles.layout}>
    <div className={styles.header}>This is the header</div>
    <div className={styles.main}>
   
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    <p>There are many variations of passages of Lorem Ipsum available, burm, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
    </div>

    <div className={styles.sidebar}>
        <p>This sidebar has the usefull links and content.</p>
       

    </div>

    <div className={styles.footer}>&copy; 2021</div>

</div>



<div className={styles.rescontainer}>
       <div className={styles.reschild}>
           oThere are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>

       <div className={styles.reschild}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>

       <div className={styles.reschild}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>
       <div className={styles.reschild}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>
       <div className={styles.reschild}>
           There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
       </div>
    </div>







</>
  )
}

export default GridScreen